//import config from "config";
import request, { makeReqOptions } from './utils/request';

const API_BASE_URL =
  import.meta.env.MODE === 'production'
    ? 'https://api.intelisine.com'
    : 'https://dev-api.intelisine.com';

export interface ContactUsPayload {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

export interface ScheduleCallPayload {
  name: string;
  email: string;
  phone: string;
  industry: string;
  message: string;
}

export interface EvaluationCallPayload {
  name: string;
  email: string;
  industry: string;
}

export interface FeedbackPayload {
  name: string;
  email: string;
  rating: number | string;
  purpose: string;
  country: string;
  feedback: string;
  state?: string;
}

export interface SubscribePayload {
  email: string;
}

export function contactus(payload: ContactUsPayload) {
  const requestUrl = `${API_BASE_URL}/v1/contactus`;
  const data = {
    firstName: payload.firstName,
    lastName: payload.lastName,
    email: payload.email,
    phone: payload.phone,
    subject: payload.subject,
    message: payload.message,
  };
  const params = {
    method: 'POST',
    data,
  };
  return request(requestUrl, makeReqOptions(params));
}

export function schedulecall(payload: ScheduleCallPayload) {
  const requestUrl = `${API_BASE_URL}/v1/schedulecall`;
  const data = {
    name: payload.name,
    email: payload.email,
    phone: payload.phone,
    industry: payload.industry,
    message: payload.message,
  };
  const params = {
    method: 'POST',
    data,
  };
  return request(requestUrl, makeReqOptions(params));
}

export function evaluationcall(payload: EvaluationCallPayload) {
  const requestUrl = `${API_BASE_URL}/v1/evaluationcall`;
  const data = {
    name: payload.name,
    email: payload.email,
    industry: payload.industry,
  };
  const params = {
    method: 'POST',
    data,
  };
  return request(requestUrl, makeReqOptions(params));
}

export function feedbacks(payload: FeedbackPayload) {
  const requestUrl = `${API_BASE_URL}/v1/feedbacks`;
  const data = {
    name: payload.name,
    email: payload.email,
    rating: payload.rating,
    purpose: payload.purpose,
    country: payload.country,
    feedback: payload.feedback,
    state: payload.state,
  };
  const params = {
    method: 'POST',
    data,
  };
  return request(requestUrl, makeReqOptions(params));
}

export function subscribe(payload: SubscribePayload) {
  const requestUrl = `${API_BASE_URL}/v1/subscribe`;
  const data = {
    email: payload.email,
  };
  const params = {
    method: 'POST',
    data,
  };
  return request(requestUrl, makeReqOptions(params));
}
